const backendDomain = "https://sanjivanierp.oakyaitservices.in/api"; // live server
// const backendDomain = "http://192.168.1.190/multi_university_apis"; // test server
//const backendDomain = "https://erpghraisoni.oakyaitservice.com/api"  
// const backendDomain = "https://sanjivanierp.oakyaitservices.in/api"



const SummaryApi = {
  uploadEmployee: {
    url: `${backendDomain}/employee/employee_create.php`,
    method: "post",
  },


  verifyEmployee: {
    url: `${backendDomain}/employee/login.php`,
    method: "post",
  },

  verifyOtp: {
    url: `${backendDomain}/employee/login.php`,
    method: "put",
  },
  uploadStudent: {
    url: `${backendDomain}/students/create.php`,
    method: "post",
  },
  updateStudent: {
    url: `${backendDomain}/students/update.php`,
    method: "post",
  },

  getStudentsByEmployeeID: {
    url: `${backendDomain}/students/retrieve.php`,
    method: "put",
  },
  getAllStudents: {
    url: `${backendDomain}/students/retrieve.php`,
    method: "get",
  },
  getAllEmployees: {
    url: `${backendDomain}/employee/retrieve.php`,
    method: "get",
  },
  getEmployeeByUniversityId: {
    url: `${backendDomain}/employee/employee_retrieve.php`,
    method: "post",
  },
  getAllConsultants: {
    url: `${backendDomain}/employee/consultant.php`,
    method: "get",
  },
  changeEmployeePassword: {
    url: `${backendDomain}/employee/update.php`,
    method: "post",
  },
  getEmployeeById: {
    url: `${backendDomain}/employee/retrieve.php`,
    method: "post",
  },
  activateEmployee: {
    url: `${backendDomain}/employee/update.php`,
    method: "put",
  },
  excelUpload: {
    url: `${backendDomain}/student_data/create.php`,
    method: "post",
  },
  verificationDuplicatesData: {
    url: `${backendDomain}/student_data/verify.php`,
    method: "POST",
  },
  getEmployeeStudentData: {
    url: `${backendDomain}/employee_student_data/retrieve.php`,
    method: "post",
  },
  bulkAction: {
    url: `${backendDomain}/employee/insert.php`,
    method: "post",
  },
  getAllInterestedStudents: {
    url: `${backendDomain}/students/interested.php`,
    method: "get",
  },
  interestedStudents: {
    url: `${backendDomain}/students/interested.php`,
    method: "post",
  },
  notInterestedStudents: {
    url: `${backendDomain}/students/not_interested.php`,
    method: "post",
  },
  getAllNotInterestedStudents: {
    url: `${backendDomain}/students/not_interested.php`,
    method: "get",
  },
  mostInterestedStudents: {
    url: `${backendDomain}/students/most_interested.php`,
    method: "post",
  },
  getAllMostInterestedStudents: {
    url: `${backendDomain}/students/most_interested.php`,
    method: "get",
  },
  callbackStudents: {
    url: `${backendDomain}/students/others.php`,
    method: "post",
  },
  getAllcallbackStudents: {
    url: `${backendDomain}/students/others.php`,
    method: "get",
  },
  employeeReport: {
    url: `${backendDomain}/employee/employee_student.php`,
    method: "get",
  },
  otherscallbackReport: {
    url: `${backendDomain}/employee/employee_student.php`,
    method: "get",
  },
  notansweredReport: {
    url: `${backendDomain}/students/not_answered.php`,
    method: "post",
  },
  getAllnotansweredReport: {
    url: `${backendDomain}/students/not_answered.php`,
    method: "get",
  },

  calllogsstudentcreate: {
    url: `${backendDomain}/student_call_log/create.php`,
    method: "post",
  },
  getcalllogsstudent: {
    url: `${backendDomain}/student_call_log/retrieve.php`,
    method: "get",
  },

  dashboardcounts: {
    url: `${backendDomain}/students/dashboard.php`,
    method: "get",
  },

  dashboardcountsById: {
    url: `${backendDomain}/students/dashboard.php`,
    method: "post",
  },

  todaystudents: {
    url: `${backendDomain}/students/today_students.php`,
    method: "get",
  },

  todaystudentsById: {
    url: `${backendDomain}/students/today_students.php`,
    method: "post",
  },

  searchstudents: {
    url: `${backendDomain}/students/search.php`,
    method: "post",
  },

  searchstudentsById: {
    url: `${backendDomain}/students/search.php`,
    method: "put",
  },

  TeamLeadEmp: {
    url: `${backendDomain}/team_lead_emp_assign/emp_assign_retrieve.php`,
    method: "POST",
  },
  getEmpDataByTLIdndEmpId: {
    url: `${backendDomain}/team_lead_emp_assign/emp_assign_retrieve.php`,
    method: "PUT",
  },
  getAllTL: {
    url: `${backendDomain}/employee/team_leads.php`,
    method: "GET",
  },
  getTLEmpCountByTLId: {
    url: `${backendDomain}/team_lead_emp_assign/dashboard.php`,
    method: "POST",
  },
  todayenrolledStudentByEmpId: {
    url: `${backendDomain}/team_lead_emp_assign/today_employee_data.php`,
    method: "POST",
  },

  getStudentDataByStudentId: {
    url: `${backendDomain}/tl_followups/student_retrieve.php`,
    method: "POST",
  },
  getTeamLeadPerformance: {
    url: `${backendDomain}/tl_followups/tl_counts.php`,
    method: "POST",
  },
  createStudentFollowDetails: {
    url: `${backendDomain}/student_follow_ups_details/create.php`,
    method: "POST",
  },
  getStudentFollowDetails: {
    url: `${backendDomain}/student_follow_ups_details/retrieve.php`,
    method: "PUT",
  },
  updateTlFollowUp: {
    url: `${backendDomain}/tl_followups/update.php`,
    method: "POST",
  },
  TlRemainders: {
    url: `${backendDomain}/tl_followups/remainder.php`,
    method: "POST",
  },
  EmpRemainders: {
    url: `${backendDomain}/tl_followups/remainder.php`,
    method: "PUT",
  },
  getTLTaskCount: {
    url: `${backendDomain}/team_lead_emp_assign/tl_data.php`,
    method: "GET",
  },
  getCallDuration3min: {
    url: `${backendDomain}/students/duration.php`,
    method: "GET",
  },
  getTodayTlAllEmpData: {
    url: `${backendDomain}/tl_followups/tl_employee_retrieve.php`,
    method: "POST",
  },
  getTlFollowupCountByEmpId: {
    url: `${backendDomain}/tl_followups/tl_employee_retrieve.php`,
    method: "PUT",
  },
  getTlFollowupHistorByEmpIdStudId: {
    url: `${backendDomain}/student_follow_ups_details/employee_retrieve.php`,
    method: "POST",
  },
  tlEmpcountStatus: {
    url: `${backendDomain}/tl_followups/tl_counts.php`,
    method: "POST",
  },
  createNotification: {
    url: `${backendDomain}/notification/notification_create.php`,
    method: "POST",
  },
  getActiveNotification: {
    url: `${backendDomain}/notification/notification_retrieve.php`,
    method: "GET",
  },
  notifictionImg: {
    url: `${backendDomain}/notification/images`,
  },
  updateNotification: {
    url: `${backendDomain}/notification/notification_update.php`,
    method: "POST",
  },
  getAllNotifications: {
    url: `${backendDomain}/notification/notification_admin_retrieve.php`,
    method: "GET",
  },
  tlEmpStatusCount: {
    url: `${backendDomain}/tl_followups/tl_emp_counts.php`,
    method: "POST",
  },
  leadClosing: {
    url: `${backendDomain}/closed_leads/closed_lead_create.php`,
    method: "POST",
  },
  getClosingLead: {
    url: `${backendDomain}/closed_leads/closed_lead_retrieve.php`,
    method: "GET",
  },
  tlDashboardCountData: {
    url: `${backendDomain}/team_lead_emp_assign/dashboard_count_data.php`,
    method: "POST",
  },

  //followup dates based on employee id and student id
  followupDatesByEmpIdStudId: {
    url: `${backendDomain}/employee_followups/student_followup_retrieve.php`,
    method: "POST",
  },

  CreateFollowupByEmployeeId: {
    url: `${backendDomain}/employee_followups/student_followup_create.php`,
    method: "POST",
  },

  TodayfollowupDatesByEmpIdStudId: {
    url: `${backendDomain}/employee_followups/student_followup_retrieve.php`,
    method: "PUT",
  },

  TodayfollowupDatesByEmpIdStudId: {
    url: `${backendDomain}/employee_followups/student_followup_retrieve.php`,
    method: "PUT",
  },

  adminsearchbar: {
    url: `${backendDomain}/students/admin_search.php`,
    method: "POST",
  },

  admindatepicker: {
    url: `${backendDomain}/students/admin_search.php`,
    method: "PUT",
  },

  studentsretreivebyemployeeid: {
    url: `${backendDomain}/students/student_retrieve.php`,
    method: "PUT",
  },

  employeesearchbar: {
    url: `${backendDomain}/students/employee_search.php`,
    method: "POST",
  },

  // team leader uppload promotional student excel data

  uploadPromotionStudentExcel: {
    url: `${backendDomain}/student_data/promotion_data_insert.php`,
    method: "POST",
  },

  getPromotionStudentExcelData: {
    url: `${backendDomain}/promotion_data/data_admin_retrieve.php`,
    method: "PUT",
  },

  getteamleademployeedata: {
    url: `${backendDomain}/promotion_data/tl_emp_data.php`,
    method: "POST",
  },

  updatepromitionfeedback: {
    url: `${backendDomain}/promotion_data/feedback_update.php`,
    method: "POST",
  },

  digitalpromotionleadsreport: {
    url: `${backendDomain}/students/digital_lead_retrieve.php`,
    method: "PUT",
  },

  //university api's

  universitycreate: {
    url: `${backendDomain}/university/university_create.php`,
    method: "POST",
  },

  universityupdate: {
    url: `${backendDomain}/university/university_update.php`,
    method: "POST",
  },
  getAllUpdataDetails: {
    url: `${backendDomain}/updata_details/updata_details_retrieve.php`,
    method: "get",
  },
  getuniversity: {
    url: `${backendDomain}/university/university_admin_retrieve.php`,
    method: "get",
  },

  getactiveuniversity: {
    url: `${backendDomain}/university/university_retrieve.php`,
    method: "get",
  },
  createUpdataDetails: {
    url: `${backendDomain}/updata_details/updata_details_create.php`,
    method: "post",
  },
  CreateDistrict: {
    url: `${backendDomain}/district/district_create.php`,
    method: "post",
  },
  GetAllDisticts: {
    url: `${backendDomain}/district/admindistrict.php`,
    method: "get",
  },
  GetActiveDisticts: {
    url: `${backendDomain}/district/district_retrieve.php`,
    method: "get",
  },
  UpdateDistrict: {
    url: `${backendDomain}/district/district_update.php`,
    method: "post",
  },

  CreateCity: {
    url: `${backendDomain}/city/city_create.php`,
    method: "post",
  },
  GetAllCities: {
    url: `${backendDomain}/city/city_admin_retrieve.php`,
    method: "get",
  },
  GetActiveCities: {
    url: `${backendDomain}/city/city_retrieve.php`,
    method: "get",
  },
  UpdateCity: {
    url: `${backendDomain}/city/city_update.php`,
    method: "post",
  },
  assignEmpToUniversity: {
    url: `${backendDomain}/university_employee_assign/university_employee_assign_create.php`,
    method: "post",
  },
  getAllEmpUniversity: {
    url: `${backendDomain}/university_employee_assign/university_employee_assign_retrieve.php`,
    method: "get",
  },
  unassignEmpFromUniversity: {
    url: `${backendDomain}/university_employee_assign/university_employee_unassign.php`,
    method: "POST",
  },



  CreateChecklist: {
    url: `${backendDomain}/checklist/checklist_create.php`,
    method: "post",
  },
  GetAllChecklists: {            // active only
    url: `${backendDomain}/checklist/checklist_retrieve.php`,
    method: "get",
  },
  GetAdminChecklists: {          // active + inactive
    url: `${backendDomain}/checklist/checklist_admin_retrieve.php`,
    method: "get",
  },
  UpdateChecklist: {
    url: `${backendDomain}/checklist/checklist_update.php`,
    method: "post",
  },


  // get weekly data
  getEmployeesWeeklyReport: {
    url: `${backendDomain}/dashboard/admin_count.php`,
    method: "post"
  },
  getEmployeesWeeklyReportByTeamLead: {
    url: `${backendDomain}/dashboard/admin_count.php`,
    method: "put"
  },
  getAllEmployeeWeeklyReportByTeamLead: {
    url: `${backendDomain}/dashboard/emp_count.php`,
    method: "put"
  },


  // get students folloups
  getAllFollowUps: {
    url: `${backendDomain}/students/followup_retrieve.php`,
    method: "get"
  },
  getAllFollowUpsByEmployee: {
    url: `${backendDomain}/students/followup_retrieve.php`,
    method: "post"
  },
  getAllFollowUpsByTeamLead: {
    url: `${backendDomain}/students/followup_retrieve.php`,
    method: "put"
  },

  // get today performance
  getTodayEmployeePerformance: {
    url: `${backendDomain}/dashboard/today_performance.php`,
    method: "get"
  },


  // getDashboardDataForTeamLead
  getDashboardDataForTeamLead: {
    url: `${backendDomain}/students/dashboard.php`,
    method: "put"
  },
  employeeImage: {
    url: `${backendDomain}/employee`
  },
  EmployeeAttendance: {
    url: `${backendDomain}/employee_attendance/emp_attendance_create.php`,
    method: "post"
  },
  AllActiveEmployee: {
    url: `${backendDomain}/employee_attendance/employee.php`,
    method: "get"
  },
  TodayActiveEmployee: {
    url: `${backendDomain}/employee_attendance/today_emp_attendance_retrieve.php`,
    method: "get"
  },
  EmployeeAttendanceLogout: {
    url: `${backendDomain}/employee_attendance/emp_attendance_create.php`,
    method: "put"
  },
  EmployeeAttendanceUpdate: {
    url: `${backendDomain}/employee_attendance/emp_attendance_update.php`,
    method: "post"
  },
};

export default SummaryApi;
